import { useState, useEffect } from 'react';
import { translations } from '../i18n/translations';

export const useTranslation = () => {
    const [language, setLanguage] = useState('en');

    useEffect(() => {
        // Detect browser language
        const browserLang = navigator.language || navigator.userLanguage;
        if (browserLang.toLowerCase().startsWith('zh')) {
            setLanguage('zh');
        } else {
            setLanguage('en');
        }
    }, []);

    const t = (key) => {
        return translations[language][key] || key;
    };

    return { t, language };
};
